module.exports = __webpack_public_path__ + "static/img_5190-b3256389215dd3b69ad6b542bfe68400.webp";